import { SiteTypes } from 'shared/enums';

export class TaskHelper {
  public static isAdvancedSiteTypeOrAbove(siteType: SiteTypes): boolean {
    return [SiteTypes.Advanced, SiteTypes.Enterprise].includes(siteType);
  }
}
